import { api } from '../../services/api'
import { showError, showSuccess } from '../misc/misc.actions'

export const movePets = (payload) => {
	return (dispatch) => {
		dispatch({ type: 'MOVE_PETS', payload })

		return api
			.post(`/movePets`, payload)
			.then((response) => {
				if (payload?.pet_ids?.length) dispatch(showSuccess('Pets moved successfully.'))
				dispatch({ type: 'POST_VISIT_SUCCESS' })
			})
			.catch((e) => {
				dispatch(showError('An error occured while moving pets.'))
				dispatch({ type: 'POST_VISIT_FAIL' })
			})
	}
}

export const addPet = (householdId, pet) => {
	return (dispatch) => {
		dispatch({ type: 'ADD_PET' })

		return api
			.post(`/clients/${householdId}/pet`, pet)
			.then((response) => {
				dispatch({ type: 'ADD_PET_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				dispatch({ type: 'ADD_PET_FAIL' })
			})
	}
}

export const uploadPetProfilePhoto = (petId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_PET' })

		return api
			.post(`/pet/${petId}/profile/image`, payload)
			.then((response) => {
				dispatch(showSuccess('Pet profile image updated successfully.'))
				dispatch({ type: 'UPDATE_PET_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				dispatch(showError('An error occured while updating the profile image.'))
				dispatch({
					type: 'UPDATE_PET_FAIL',
					payload: e
				})
			})
	}
}

export const getPetStaffNotes = async (dispatch, pet_id) => {
	if (!pet_id) {
		return
	}
	try {
		let { data } = await api.get(`/pet/${pet_id}/staffNotes`)
		if (data.data && data.data.length) {
			dispatch({ type: 'UPDATE_PET_STAFF_NOTES', payload: { _id: pet_id, staff_notes: data.data } })
		}
	} catch (e) {
		console.log('error getting staff notes', e)
		dispatch({
			type: 'UPDATE_PET_FAIL',
			payload: error || 'An error occured while getting pet notes.'
		})
	}
}

/**
 * Same logic as updatePet, but with async/await pattern
 * @param {function} dispatch - dispatch function from redux
 * @param {string} pet_id
 * @param {object} updates
 * @returns object | null
 */
export const updatePetAsync = async (dispatch, pet_id, updates) => {
	dispatch({ type: 'UPDATE_PET' })
	try {
		const response = await api.patch(`/pet/${pet_id}`, updates)
		dispatch(showSuccess(`Pet updated!`))
		dispatch({ type: 'UPDATE_PET_SUCCESS', payload: response.data })
		return response
	} catch (e) {
		console.log(e)
		const error = e?.response?.data || e?.data || 'An error occurred while updating the selected pet'
		dispatch(showError(error))
		dispatch({
			type: 'UPDATE_PET_FAIL',
			payload: error || 'An error occured while updating the selected pet.'
		})
		return null
	}
}

export const updatePet = (pet_id, updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_PET' })

		return api
			.patch(`/pet/${pet_id}`, updates)
			.then((response) => {
				dispatch(showSuccess(`Pet updated!`))
				dispatch({ type: 'UPDATE_PET_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				// console.log(e)
				const error = e?.response?.data || e?.data || 'An error occurred while updating the selected pet'
				dispatch(showError(error))
				dispatch({
					type: 'UPDATE_PET_FAIL',
					payload: error || 'An error occured while updating the selected pet.'
				})
			})
	}
}

export const deletePet = (id) => {
	return (dispatch) => {
		dispatch({ type: 'REMOVE_PET' })

		return api
			.delete(`/pet/${id}`)
			.then((response) => {
				dispatch(showSuccess('Pet removed successfully.'))
				dispatch({ type: 'REMOVE_PET_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error = e && e.response && e.response.data ? e.response.data : null
				if (error) dispatch(showError(error))
				dispatch({ type: 'REMOVE_PET_FAIL', payload: error })
			})
	}
}

export const updatePetInventory = (updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_INVENTORY' })

		return api
			.patch(`/updateInventory`, updates)
			.then((response) => {
				dispatch(showSuccess('Pet inventory updated successfully.'))
				dispatch({ type: 'UPDATE_INVENTORY_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				const error = e && e.response && e.response.data ? e.response.data : null
				if (error) dispatch(showError(error))
				dispatch({ type: 'UPDATE_PET_INVENTORY', payload: error })
			})
	}
}
